import { useCallback } from 'react';

import { useBannerDismissalStorage } from '../../../../../PageBanner/hooks/useBannerDismissalStorage';
import { ENDORSEMENTS_BANNER_KEY } from '../../../../shared/constants';

type UseEndorsementsBannerReturn = ModelHookResult<{ isDismissed: boolean }, { handleDismiss: () => void }>;

export function useEndorsementsBanner(): UseEndorsementsBannerReturn {
	const { isBannerDismissed, setBannerDismissed } = useBannerDismissalStorage();

	const isDismissed = isBannerDismissed(ENDORSEMENTS_BANNER_KEY);

	const handleDismiss = useCallback(() => {
		setBannerDismissed(ENDORSEMENTS_BANNER_KEY);
	}, [setBannerDismissed]);

	return {
		data: { isDismissed },
		actions: { handleDismiss },
	};
}
